import React, {Component} from 'react';
import ShopPage from './shop_page';
import FootCourtPage from './food_court_home_page';
import LoadingPage from './loading_page/loading_page';
import {observer, inject} from 'mobx-react';
import queryString from 'query-string';
import {HALL_PAGE} from '../constants';
import * as Sentry from '@sentry/browser';
import TVDisabledPage from "./tv_disabled_page";

function determinePageToRender({displayLoadingScreen, hasError, currentPage, designType, isTVEnabled}) {
    if(displayLoadingScreen || hasError) {
        return <LoadingPage designType={designType}/>;
    } else if(!isTVEnabled) {
        return <TVDisabledPage/>;
    } else if(currentPage === HALL_PAGE) {
        return <FootCourtPage/>;
    } else {
        return <ShopPage/>;
    }
}


@inject('RootStore')
@observer
export default class App extends Component {

    componentWillMount(){
        //immediately grab the display id from the url, and add it to the store.
        this.props.RootStore.configStore.setDisplayId(queryString.parse(this.props.location.search).display_id);
        //the main entry point to connect the app to the backend!
        this.props.RootStore.initialize();
    }

    //this is global catch to catch an error anywhere in the app
    componentDidCatch(error, info) {
        console.log(`There was an error: ${error}`);
        console.log(`Error info: ${info}`);
        window.S3ETAGCHECKRATE = 5000;
        Sentry.withScope(scope => {
            scope.setExtra('info', info)
            Sentry.captureException(error)
        })
        this.props.RootStore.configStore.setHasError();
    }


    render() {
        const configStore = this.props.RootStore.configStore;
        const mainPage = determinePageToRender(configStore);
        const styleStore = this.props.RootStore.styleStore;
        const isShopOpen = this.props.RootStore.configStore.isShopOpen;
        const bgColor = isShopOpen ? styleStore.currentStylesDict.backGroundColor : styleStore.currentStylesDict.closedShopBackgroundColor;
        return (
            <div width="100%" height="100%" style={{backgroundColor: bgColor}}>
                {mainPage}
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/components/App.js